import React from 'react';
import { useNotifications } from '../../contexts/NotificationContext';

interface NotificationBellProps {
  onClick: () => void;
  isOpen: boolean;
}

export const NotificationBell: React.FC<NotificationBellProps> = ({ onClick, isOpen }) => {
  const { unreadCount, criticalCount } = useNotifications();

  return (
    <button
      onClick={onClick}
      className={`relative p-2 rounded-full transition-colors ${
        isOpen 
          ? 'bg-blue-100 text-blue-700' 
          : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700'
      }`}
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
      aria-expanded={isOpen}
    >
      {/* Bell Icon */}
      <svg 
        className="w-6 h-6" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" 
        />
      </svg>

      {/* Unread Badge */}
      {unreadCount > 0 && (
        <span 
          className={`absolute -top-0.5 -right-0.5 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-xs font-bold text-white rounded-full ${
            criticalCount > 0 ? 'bg-red-600 animate-pulse' : 'bg-blue-600'
          }`}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}

      {/* Critical indicator ring */}
      {criticalCount > 0 && (
        <span className="absolute inset-0 rounded-full ring-2 ring-red-400 ring-opacity-50 animate-ping" />
      )}
    </button>
  );
};
